import React, { useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";

const Testcsrf = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loginSuccessful, setLoginSuccessful] = useState(false);
  const [csrfToken, setCsrfToken] = useState(null);

  // Function to fetch the CSRF token and set it in state
  const setCsrfCookie = async () => {
    try {
      const response = await axios.get(
        "http://192.168.1.11:8000/core/csrf-ensure/",
        {
          withCredentials: true, // Make sure credentials (cookies) are sent
        }
      );

      if (response.ok) {
        // Extract the CSRF token from cookies
        const cookies = document.cookie.split(";");
        console.log(response);
        let token = null;
        cookies.forEach((cookie) => {
          const [name, value] = cookie.split("=").map((c) => c.trim());
          if (name === "csrftoken") {
            token = value;
          }
        });

        if (token) {
          console.log("CSRF Token:", token);
          setCsrfToken(token); // Set CSRF token in state
        } else {
          console.log("CSRF cookie not found");
        }
      } else {
        console.log("Failed to fetch CSRF token");
      }
    } catch (error) {
      console.error("Error fetching CSRF token:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await fetch("http://192.168.1.11:8000/core/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken, // Include the CSRF token in the headers
        },
        credentials: "include", // Ensure credentials (cookies) are sent
        body: JSON.stringify({
          username,
          password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setLoginSuccessful(true);
      } else {
        const errorData = await response.json();
        setLoginSuccessful(false);
        setError("Error logging in: " + errorData.detail || "Unknown error");
      }
    } catch (err) {
      setLoginSuccessful(false);
      setError("Error logging in: " + err.message);
    }
  };

  return (
    <div className="container py-5 my-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="form-group">
            <button onClick={setCsrfCookie}>Set CSRF Token</button>
          </div>
        </div>
      </div>

      <div className="row py-5 my-5 justify-content-center">
        <div className="col-md-6 my-5">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center">Login</h3>
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  Login
                </button>
              </form>
            </div>
            <div dir="ltr" className="m-5">
              CSRF Token: {csrfToken || "Not set yet"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testcsrf;
